import {_figures} from "../_section/_figures";

export class Figures extends _figures{
    constructor({section}) {
        super({
            section,
            formName: ['funds', 'gifts'],
        });
    }
    get claimedFigure(){
        return this.mortgage.requirement.depositGifts || 0
    }

    get verifiedFigure(){
        if (!this.activeUploads.length){
            this.warn(`No active uploads`);
            return 0;
        }
        const sum = this.activeUploads.reduce( (acc, upload) => {
            if (upload.values.amount) {
                this.add(`Gift Letter from ...`, upload.values.amount, upload.id );
                return acc + parseFloat(upload.values.amount);
            }
            else{
                this.warn(`An Upload is missing amount value`);
            }
            return acc;
        },0)
        this.append({
            description: 'Total',
            amount: sum,
            uploadID: null,
            operator: '='
        })
        this.total(sum)
        return sum;
    }

}